import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";

export default function Footer() {
  const settings = useSettings();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
              <img src="/assets/branding/logo.png" alt="Logo" style={{ width: '40px', height: '40px', borderRadius: '8px', objectFit: 'cover' }} />
              <h2 style={{ margin: 0 }}>{settings.site_name || "HandyCraft Bali"}</h2>
            </div>
            <p className="footer-text">
              {settings.about_text || "Membawa keindahan dan keotentikan seni kerajinan tangan Bali ke seluruh penjuru dunia."}
            </p>
          </div>

          <div className="footer-links">
            <h4>Navigasi</h4>
            <ul>
              <li><Link to="/">Beranda</Link></li>
              <li><Link to="/products">Koleksi Produk</Link></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>Hubungi Kami</h4>
            <ul>
              <li style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '10px' }}>
                📍 {settings.contact_address || "Bali, Indonesia"}
              </li>
              <li style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '10px' }}>
                📞 {settings.contact_phone || "+62 812-3456-789"}
              </li>
              <li style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '10px' }}>
                ✉️ {settings.contact_email || "hello@handycraft.bali"}
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} {settings.site_name || "HandyCraft Bali"}. All rights reserved.</p>
          <div style={{ display: 'flex', gap: '20px' }}>
             <Link to="/login" style={{ fontSize: '0.8rem', opacity: 0.5 }}>Login Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
